export const letterSpacingMedium = '0px';
export const letterSpacingLarge = '0.1px';
export const letterSpacingXL = '0.3px';

// https://pixelsconverter.com/em-to-px
export const letterSpacingXXL = '0.04em'; // 0.64px on base 16px
